<div class="ads-container">
  <app-page-top-section
    [titleData]="'ADS.PAGE_TITLE' | translate"></app-page-top-section>
  <app-search-area></app-search-area>
  <section class="product-main area-pink">
    <div class="container">
      <div class="product-list-main">
        <app-product-list-right
          [title]="'ADS.ALL_ADS_CATEGORY.TITLE' | translate"
          [filter]="{ filter: { vip: true } }"
          [vipOnly]="true">
        </app-product-list-right>
      </div>
    </div>
  </section>

  <section class="product-main">
    <div class="container">
      <div class="product-list-main">
        <app-product-list-right
          [title]="'PRODUCT_LIST.ALL_SEX_ADS_IN_MYESCORT' | translate"
          [filter]="{ filter: undefined }"
          [showBreadcrumbs]="true">
        </app-product-list-right>
      </div>
    </div>
  </section>
</div>
